/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RefundInfoDTO } from '../models/RefundInfoDTO';
import type { RetranscribeRequestDTO } from '../models/RetranscribeRequestDTO';
import type { TranscriptionJobDTO } from '../models/TranscriptionJobDTO';
import type { TranscriptionResponseDTO } from '../models/TranscriptionResponseDTO';
import type { TranscriptionUpdateDTO } from '../models/TranscriptionUpdateDTO';
import type { YouTubeParameters } from '../models/YouTubeParameters';
import type { YoutubePopularSongResponseDTO } from '../models/YoutubePopularSongResponseDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TranscriptionService {

    /**
     * Return all transcriptions belonging to the authorized user or an empty list.
 * The transcription can be fildered by the transcription type for the specific application
 * like Piano2Notes, Guitar2Tabs ...
     * @param type Appname to filter the transcriptions for, defaults to "piano2notes"
     * @returns TranscriptionResponseDTO Returns all transcriptions belonging to the user.
     * @throws ApiError
     */
    public static transcriptionGetMyFilesGet(
type: string | null = 'piano2notes',
): CancelablePromise<Array<TranscriptionResponseDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Transcription/my_files',
            query: {
                'type': type,
            },
        });
    }

    /**
     * Return all transcriptions belonging to the authorized user or an empty list.
 * The transcription can be fildered by the transcription type for the specific application
 * like Piano2Notes, Guitar2Tabs ...
     * @param type Appname to filter the transcriptions for, defaults to "piano2notes"
     * @returns TranscriptionResponseDTO Returns all transcriptions belonging to the user.
     * @throws ApiError
     */
    public static transcriptionGetMyFilesPost(
type: string | null = 'piano2notes',
): CancelablePromise<Array<TranscriptionResponseDTO>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Transcription/my_files',
            query: {
                'type': type,
            },
        });
    }

    /**
     * Return a specific transcription identified by the given id.
     * @param id Id of the transcription to fetch.
     * @returns TranscriptionResponseDTO Transcription from the database
     * @throws ApiError
     */
    public static transcriptionGetGet(
id?: string,
): CancelablePromise<TranscriptionResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Transcription/get',
            query: {
                'id': id,
            },
            errors: {
                404: `Cannot fetch the transcription with the given Id`,
            },
        });
    }

    /**
     * Return a specific transcription identified by the given id.
     * @param id Id of the transcription to fetch.
     * @returns TranscriptionResponseDTO Transcription from the database
     * @throws ApiError
     */
    public static transcriptionGetPost(
id?: string,
): CancelablePromise<TranscriptionResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Transcription/get',
            query: {
                'id': id,
            },
            errors: {
                404: `Cannot fetch the transcription with the given Id`,
            },
        });
    }

    /**
     * Delete a transcription with the given id.
     * @param id Id of the transcription to delete
     * @returns any Transcription was deleted successfully
 * or
 * Transcription is already removed or cannot be found
     * @throws ApiError
     */
    public static transcriptionDelete(
id?: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Transcription/delete',
            query: {
                'id': id,
            },
            errors: {
                403: `Request is not authenticated`,
            },
        });
    }

    /**
     * Update subset of transcription attributes.
     * @param requestBody Contains the updated attributes of the transcription
     * @returns TranscriptionResponseDTO Returns updated transcription
     * @throws ApiError
     */
    public static transcriptionUpdateTranscription(
requestBody: TranscriptionUpdateDTO,
): CancelablePromise<TranscriptionResponseDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Transcription/update',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Could not find the transcription with the given data`,
            },
        });
    }

    /**
     * @param id 
     * @returns binary 
     * @throws ApiError
     */
    public static transcriptionGetTranscriptionUpdate(
id?: string,
): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Transcription/transcriptionProgress',
            query: {
                'id': id,
            },
        });
    }

    /**
     * Unlock a demo sheet. Will create a new full transcription based on the
 * audio and parameters from the demo transcription.
     * @param id Id of the demo transcription to unlock
     * @returns TranscriptionJobDTO Contains the id of the new transcription/job
     * @throws ApiError
     */
    public static transcriptionUnlock(
id?: string,
): CancelablePromise<TranscriptionJobDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Transcription/unlock',
            query: {
                'id': id,
            },
            errors: {
                400: `User has not enough tickets to unlock the transcription`,
                401: `User was not authorized to unlock this sheet`,
            },
        });
    }

    /**
     * Retranscribe an existing sheet with the new parameters.
     * @param requestBody Contains Id to identify the sheet and new parameters for transcription
     * @returns binary Start a retranscription of an existing transcription
     * @throws ApiError
     */
    public static transcriptionRetranscribeSheet(
requestBody: RetranscribeRequestDTO,
): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Transcription/retranscribe',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `User is not allowed to create a retranscription of this sheet`,
                404: `Sheet to retranscribe cannot be found in the database`,
            },
        });
    }

    /**
     * @param id 
     * @returns binary 
     * @throws ApiError
     */
    public static transcriptionAccept(
id?: string,
): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Transcription/accept',
            query: {
                'id': id,
            },
        });
    }

    /**
     * Refund a transcription with the given id
     * @param id Id of the transcription to refund
     * @param requestBody Optional info about the refund
     * @returns binary Defaults to ok, even if the refund didn't work
     * @throws ApiError
     */
    public static transcriptionRefund(
id?: string,
requestBody?: RefundInfoDTO,
): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Transcription/refund',
            query: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Refund request could not be processed`,
                404: `Transcription does not exist`,
            },
        });
    }

    /**
     * Create a youtube transcription
     * @param requestBody Paramters to be used for the transcription
     * @returns TranscriptionJobDTO Default response containing the job description object
     * @throws ApiError
     */
    public static transcriptionYouTube(
requestBody: YouTubeParameters,
): CancelablePromise<TranscriptionJobDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Transcription/youtube',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Create a transcription based on the uploaded file.
 * Current Upload Limit is 100Mb
     * @param formData 
     * @returns TranscriptionJobDTO TranscriptionJobDTO
     * @throws ApiError
     */
    public static transcriptionUpload(
formData?: {
File?: Blob | null;
UseCredits?: boolean;
UseTickets?: boolean;
Source?: string | null;
Type?: string | null;
Params?: string | null;
Title?: string | null;
},
): CancelablePromise<TranscriptionJobDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Transcription/upload',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `If user is authenticated but cannot be found.
or
File content is missing in formdata`,
            },
        });
    }

    /**
     * Fetch the midi file given by the transcription id.
     * @param id Id of the transcription the midi file belongs to
     * @returns binary Returns the binary midi file with MIME type 'audio/midi' set
     * @throws ApiError
     */
    public static transcriptionMidi(
id?: string,
): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Transcription/midi',
            query: {
                'id': id,
            },
            errors: {
                500: `If an exception occured while fetching the file`,
            },
        });
    }

    /**
     * Fetch the unquantized midi file given by the transcription id.
     * @param id Id of the transcription the midi file belongs to
     * @returns binary File response with the binary audio/midi MIME response
     * @throws ApiError
     */
    public static transcriptionUnquantizedMidi(
id?: string,
): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Transcription/midi_unquantized',
            query: {
                'id': id,
            },
        });
    }

    /**
     * Get the original uploaded audio of the transcription as mp3.
     * @param id Id of the transcription
     * @returns binary Binary audio/mp3 MIME response
     * @throws ApiError
     */
    public static transcriptionMp3(
id?: string,
): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Transcription/mp3',
            query: {
                'id': id,
            },
        });
    }

    /**
     * Get the synthetic audio representation of the transcription as mp3.
     * @param id Id of the transcription
     * @returns binary Binary audio/mp3 MIME response
     * @throws ApiError
     */
    public static transcriptionSynth(
id?: string,
): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Transcription/synth',
            query: {
                'id': id,
            },
        });
    }

    /**
     * Returns binary pdf file for the given transcription id
     * @param id Id of the transcription
     * @returns binary Binary application/pdf file of the transcription
     * @throws ApiError
     */
    public static transcriptionPdf(
id?: string,
): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Transcription/pdf',
            query: {
                'id': id,
            },
        });
    }

    /**
     * Get the MusicXml file of the transcription
     * @param id Id of the transcription
     * @returns binary Plain text encoded Xml representation of the transcription
     * @throws ApiError
     */
    public static transcriptionMusicXml(
id?: string,
): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Transcription/xml',
            query: {
                'id': id,
            },
        });
    }

    /**
     * @param id 
     * @returns binary 
     * @throws ApiError
     */
    public static transcriptionLilypond(
id?: string,
): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Transcription/lilypond',
            query: {
                'id': id,
            },
        });
    }

    /**
     * Get the music json of a transcription in Json response format
     * @param id Id of the transcription
     * @returns binary Json encoded music json
     * @throws ApiError
     */
    public static transcriptionMusicJson(
id?: string,
): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Transcription/musj',
            query: {
                'id': id,
            },
        });
    }

    /**
     * Update a music json. Will be completely overwritten by the new data.
 * Cannot be undone!
     * @param formData 
     * @returns any MusicJson file updated
     * @throws ApiError
     */
    public static transcriptionUpdateMusicJson(
formData?: {
Id?: string;
File?: Blob | null;
},
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Transcription/musj',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Could not store music json`,
                401: `User is not authorized`,
                403: `Not allowed to update this music json`,
            },
        });
    }

    /**
     * Fetch the Guitar Pro 5 File for the given Transcription Id and return in binary byte array.
     * @param id Id of the transcription the GP5 file belongs to.
     * @returns binary Returns the guitar pro 5 file in binary byte array
     * @throws ApiError
     */
    public static transcriptionGuitarPro(
id?: string,
): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Transcription/gp',
            query: {
                'id': id,
            },
            errors: {
                500: `Could not fetch the guitar pro file from storage`,
            },
        });
    }

    /**
     * Claim a Transcription that does not belong to a user.
     * @param id Guid of the Transcription to claim
     * @returns TranscriptionResponseDTO Returned with updated Transcription that is assigned to authenticated user.
     * @throws ApiError
     */
    public static transcriptionClaimTranscription(
id?: string,
): CancelablePromise<TranscriptionResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Transcription/claim',
            query: {
                'id': id,
            },
            errors: {
                400: `When transcription Id is not provided.`,
                401: `User is not authroized`,
                403: `Transcription already belongs to other user.`,
                404: `The transcription with the given id cannot be found.`,
            },
        });
    }

    /**
     * Returns popular Youtube songs for the given app name,
 * to be used for our transcription system.
     * @param appName Name of the app in lowercase
     * @returns YoutubePopularSongResponseDTO List of popular youtube songs
     * @throws ApiError
     */
    public static transcriptionGetPopularSongs(
appName: string | null = 'piano2notes',
): CancelablePromise<Array<YoutubePopularSongResponseDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Transcription/popular',
            query: {
                'appName': appName,
            },
        });
    }

}
